import {createContext} from "react";
import {MessageItemListStruct} from "../data/MessageData";

const MessageRecordMgr = createContext({
    messageItemList: {...MessageItemListStruct}, messageItemDispatcher: (state, action) => {
    }
});

export const MessageContext = {MessageRecordMgr};
